import { createSlice } from '@reduxjs/toolkit'
import { contentThunk } from './ContentThunk';

const contentSlice = createSlice({
  name: 'contentSlice',
  initialState: {
    loading: false,
    content: [],
  },
  reducers: {
    clearContentSlice: (state) => {
      state.loading = false;
      state.content = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contentThunk.fulfilled, (state, action) => {
        const ditaFile = action.meta.arg;
        state.content.push({ ditafile: ditaFile, content: action.payload });
      })
  }
});


export const getDitaContent = (ditafilePath, content, dispatch) => {
  const ditaContent = content?.content?.find(
    (c) => c.ditafile === ditafilePath,
  );

  if (!ditaContent) {
    dispatch(contentThunk(ditafilePath));
    return null;
  }

  const parser = new DOMParser();
  return parser.parseFromString(ditaContent.content, "text/xml");
};


export const { clearContentSlice } = contentSlice.actions;
export const selectDitaContent = state => state.content;
export default contentSlice.reducer;